export function swapElements(arr, i1, i2) {
    arr[i1] = arr.splice(i2, 1, arr[i1])[0];
    return arr;
}
export function swapCoordinatesArr(coordinates) {
    coordinates[0] = coordinates[0].map((coord) => swapElements(coord, 0, 1));
    return coordinates;
}
